import { getApi,postApi } from "../../config/api";

export const HomingService = {

    "Collector Home X": async function (){
        return false;
    },

    "Collector Home Y": async function (){
        return false;
    },

    "Collector Home Z": async function (){
        return false;
    },

    "Collector Home A": async function (){
        return false;
    },

    "Mixer Home X": async function (){
        return false;
    },

    "Mixer Home Y": async function (){
        return false;
    },

    "Mixer Home A": async function (){
        return false;
    },
};